var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 0A6.5 6.5 0 1 0 13 6.5 6.508 6.508 0 0 0 6.5 0Z",
  fill: "#00BAC6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.44 4.788 6.28 9.451a.548.548 0 0 1-.782.03L3.06 7.126a.542.542 0 1 1 .753-.78l2.033 1.965L9.632 4.07a.542.542 0 1 1 .808.719Z",
  fill: "#fff"
})));
export { SvgCircleCheckmark as ReactComponent };
export default __webpack_public_path__ + "b8490da5bef9a6bcf6b8fe570cd352d2.svg";